import 'shared/global';
import Domain from 'helpers/Domain';
import { AbTestModuleLoader } from '../abTests/lib/AbTestModuleLoader';

// START A/B TEST PLGRWEB-1380 - Browse Filter on "All"
import { initializeBrowseFilterAll } from 'abTests/testClasses/BrowseFilterOnAll';
initializeBrowseFilterAll('show');
// END A/B TEST PLGRWEB-1380 - Browse Filter on "All"

// ab test framework - auto run xhr tests
window.addEventListener('DOMContentLoaded', function () {
    new AbTestModuleLoader();
});

if (Domain.isDomestic()) {
    import('components/showBrowse').then((module) => {
        const ShowBrowse = module.default;

        try {
            let __ShowBrowse = new ShowBrowse();
        } catch (e) {
            console.error('ShowBrowse component failed to load.', e.message);
        }
    });
} else if (Domain.isInternational()) {
    import('components/browse').then((module) => {
        const Browse = module.default;

        try {
            let __ShowBrowse = new Browse('shows');
        } catch (e) {
            console.error('ShowBrowse component failed to load.', e.message);
        }
    });
}
